<template>
  <div class="content-contents">
    <v-form ref="profileForm">
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="userObject.firstName"
            :label="local.complaints.complaintDetails.complaintUserInfo.firstName"
            class="view-input"
            disabled
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="userObject.secondName"
            :label="local.complaints.complaintDetails.complaintUserInfo.fatherName"
            class="view-input"
            disabled
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="userObject.thirdName"
            :label="local.complaints.complaintDetails.complaintUserInfo.grandfatherName"
            class="view-input"
            disabled
          ></naj-input>
        </v-col>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="userObject.familyName"
            :label="local.complaints.complaintDetails.complaintUserInfo.familyName"
            class="view-input"
            disabled
          ></naj-input>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="userObject.officialId"
            :label="local.complaints.complaintDetails.complaintUserInfo.identityNumber"
            class="view-input"
            disabled
          ></naj-input>
        </v-col>

        <v-col cols="3">
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="userObject.nationality"
            :label="local.complaints.complaintDetails.complaintUserInfo.nationality"
            class="view-input"
            disabled
          ></naj-input>
        </v-col>

        <v-col
          v-if="userObject.isMobileVerfied"
          cols="3"
        >
          <naj-input
            :type-id="formFieldType.text"
            :value.sync="userObject.mobileNo"
            :label="local.complaints.complaintDetails.complaintUserInfo.mobileNumber"
            class="view-input"
            disabled
          ></naj-input>
        </v-col>
      </v-row>
      <v-row>
        <template v-if="(showModifyMobile && isProfile) || (showModifyMobile && !isProfile && !userObject.isMobileVerfied)">
          <v-col cols="3">
            <naj-input
              v-mask="'05########'"
              :type-id="formFieldType.text"
              :value.sync="editedMobileNo"
              :label="local.complaints.complaintDetails.complaintUserInfo.editMobileNumber"
              :validates="`required|digits:10`"
              class="view-input"
            ></naj-input>
          </v-col>
          <v-col
            cols="3"
            class="align_button"
          >
            <naj-button @click="verifyNumber">
              {{ local.complaints.complaintDetails.complaintUserInfo.verifyNumber }}
            </naj-button>
          </v-col>
        </template>
      </v-row>
    </v-form>
    <mobile-verification-modal
      :modal-visibility="showMobileVerification"
      @onClose="closeMobileVerificationModal"
      @onResend="resendMobileVerification"
    >
    </mobile-verification-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import MobileVerificationModal from './mobile-verification-modal.vue';
const { mapActions: mapComplaintsActions } = createNamespacedHelpers('ComplaintsModule');

export default {
  name: 'Profile',
  components: { MobileVerificationModal },
  props: {
    isProfile: {
      type: Boolean,
      default: false,
      required: false,
    },
    showModifyMobile: {
      type: Boolean,
      default: true,
      required: false,
    },
    userObject: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showMobileVerification: false,
      editedMobileNo: null,
    };
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {
    ...mapComplaintsActions([
      'generateMobileCode',
    ]),
    verifyNumber() {
      this.$refs.profileForm.$validator.validateAll()
        .then((valid) => {
          if (valid) {
            this.generateMobileCode(this.editedMobileNo || this.userObject.mobileNo)
              .then((data) => {
                if (data.data == true) {
                  this.showMobileVerification = true;
                }
              });
          }
        });
    },
    closeMobileVerificationModal() {
      this.showMobileVerification = false;
      this.editedMobileNo = null;
      this.$emit('onClose');
    },
    resendMobileVerification() {
      this.verifyNumber();
    },
  },
};
</script>
<style lang="scss" scoped>
.align_button {
  display: flex;
  align-items: center;
}
</style>
